import { render, staticRenderFns } from "./summaryIntro.vue?vue&type=template&id=5b5b7971&scoped=true"
import script from "./summaryIntro.vue?vue&type=script&lang=js"
export * from "./summaryIntro.vue?vue&type=script&lang=js"
import style0 from "./summaryIntro.vue?vue&type=style&index=0&id=5b5b7971&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b7971",
  null
  
)

export default component.exports